import React, { FC, Fragment, useState } from 'react';
import { NetworkStatus, useQuery } from '@apollo/client';
import Loader from 'components/shared/loader/loader.component';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import TransportOrdersPageActions from 'components/transport-admin/transport-orders-page-actions/transport-orders-page-actions.component';
import { TransportFilter, TransportOrder, TransportOrderFilter } from 'models/transport';
import TransportOrderList from 'components/transport-admin/transport-order-list/transport-order-list.component';
import { transportsTemplate } from 'apollo/templates/transport';

const TransportOrders: FC = () => {
    const [lastOffset, setLastOffset] = useState(0);
    const [transportOrders, setTransportOrders] = useState<TransportOrder[]>([]);
    const [transportFilters, setTransportFilters] = useState<TransportOrderFilter>({});
    const { showBoundary } = useDenthubErrorBoundary();
    const { loading, fetchMore, networkStatus } = useQuery(transportsTemplate, {
        notifyOnNetworkStatusChange: true,
        variables: { limit: 20, offset: 0, filters: transportFilters },
        onCompleted: ({ transports }) => {
            setTransportOrders(transports);
            setLastOffset(transports.length);
        },
        onError(error) {
            showBoundary(error);
        },
    });

    const handleFilterChange = (filters: TransportFilter) => {
        setTransportFilters(filters);
        setLastOffset(0);
    };

    const handleFetchMore = () => {
        if (fetchMore) {
            fetchMore({
                variables: {
                    offset: lastOffset,
                    filters: transportFilters,
                },
            });
        }
    };

    const resolveTransportProblemFlag = (transportId: string) => {
        const transports = JSON.parse(JSON.stringify(transportOrders));
        const index = transports.findIndex((transport: TransportOrder) => transport._id === transportId);
        if (index !== -1) {
            transports[index].hasProblem = false;
            transports.splice(index, 1, transports[index]);
            setTransportOrders(transports);
        }
    };

    const updateTransport = (transport: TransportOrder) => {
        const transports = JSON.parse(JSON.stringify(transportOrders));
        const index = transports.findIndex((trans: TransportOrder) => trans._id === transport._id);
        if (index !== -1) {
            transports.splice(index, 1, transport);
            setTransportOrders(transports);
        }
    };

    return (
        <Fragment>
            <TransportOrdersPageActions onFilterChange={handleFilterChange} />
            {loading && networkStatus !== NetworkStatus.fetchMore ? (
                <Loader />
            ) : (
                <TransportOrderList
                    transportOrders={transportOrders}
                    onFetchMore={handleFetchMore}
                    resolveTransportProblemFlag={resolveTransportProblemFlag}
                    onUpdateTransport={updateTransport}
                />
            )}
        </Fragment>
    );
};

export default TransportOrders;
